<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-content-switcher [ttSelectedId]="page.bg_srexpenses_main" (ttSelectedIdChange)="onViewChanged($event)">
            <tt-switch ttId="TREATMENT" ttText="bg_srexpenses_main_treatment"></tt-switch>
            <tt-switch ttId="WAITING" ttText="bg_srexpenses_main_waiting"></tt-switch>
            <tt-switch ttId="FINISHED" ttText="bg_srexpenses_main_finished"></tt-switch>
        </tt-content-switcher>
        <tt-input ttLabel="searchtext" [ttModel]="page.searchtext" (ttModelChange)="onSearchChanged($event)" ttShowClearButton [ttClearValue]="''"></tt-input>
        <tt-date-range [hidden]="page.bg_srexpenses_main !== 'FINISHED'" ttLabel="paid_date_fom_tom" [ttModel]="page" (ttModelChange)="onDatesChanged($event)"></tt-date-range>
    </tt-card>
    <tt-list [ttData]="filteredItems" ttBackStyle [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
</tt-page>
